<template>
  <div id="chart">
    <apexchart type="bar" height="350" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts"
import { topTenActivities, getDistrictsActivies, getLocationActivities } from "../databaseRequests"

var districtLabels = ["Braga", "Porto"]
var districtActivities = [
  {key: "Braga135", value:{'Location.district': "Braga", 'Activity.id': 135, 'Activity.activity': "Cafés", 'Facts.count': 215, 'Facts.providesService': 0}},
  {key: "Braga411", value:{'Location.district': "Braga", 'Activity.id': 411, 'Activity.activity': "Compra e venda de bens imobiliários", 'Facts.count': 858, 'Facts.providesService': 0}},
  {key: "Braga412", value: {'Location.district': "Braga", 'Activity.id': 412, 'Activity.activity': "Restaurantes tipo tradicional", 'Facts.count': 460, 'Facts.providesService': 0}},
  {key: "Braga414", value: {'Location.district': "Braga", 'Activity.id': 414, 'Activity.activity': "Construção de edifícios (residenciais e não residenciais)", 'Facts.count': 13, 'Facts.providesService': 0}},
  {key: "Braga419", value: {'Location.district': "Braga", 'Activity.id': 419, 'Activity.activity': "Actividades de contabilidade e auditoria;  consultoria fiscal", 'Facts.count': 550, 'Facts.providesService': 0}},
  {key: "Braga424", value: {'Location.district': "Braga", 'Activity.id': 424, 'Activity.activity': "Outras actividades de consultoria para os negócios e a gestão", 'Facts.count': 284, 'Facts.providesService': 0}},
  {key: "Braga554", value: {'Location.district': "Braga", 'Activity.id': 554, 'Activity.activity': "Transportes rodoviários de mercadorias", 'Facts.count': 320, 'Facts.providesService': 0}},
  {key: "Braga484", value: {'Location.district': "Braga", 'Activity.id': 484, 'Activity.activity': "Actividades de mediação imobiliária", 'Facts.count': 379, 'Facts.providesService': 0}},
  {key: "Braga494", value: {'Location.district': "Braga", 'Activity.id': 494, 'Activity.activity': "Manutenção e reparação de veículos automóveis", 'Facts.count': 482, 'Facts.providesService': 0}},
  {key: "Braga495", value: {'Location.district': "Braga", 'Activity.id': 419, 'Activity.activity': "Confecção de outro vestuário exterior em série", 'Facts.count': 1351, 'Facts.providesService': 0}},
  {key: "Porto135", value: {'Location.district': "Porto", 'Activity.id': 135, 'Activity.activity': "Cafés", 'Facts.count': 923, 'Facts.providesService': 0}},
  {key: "Porto411", value: {'Location.district': "Porto", 'Activity.id': 411, 'Activity.activity': "Compra e venda de bens imobiliários", 'Facts.count': 2060, 'Facts.providesService': 0}},
  {key: "Porto412", value: {'Location.district': "Porto", 'Activity.id': 412, 'Activity.activity': "Restaurantes tipo tradicional", 'Facts.count': 1451, 'Facts.providesService': 0}},
  {key: "Porto414", value: {'Location.district': "Porto", 'Activity.id': 414, 'Activity.activity': "Construção de edifícios (residenciais e não residenciais)", 'Facts.count': 3118, 'Facts.providesService': 0}},
  {key: "Porto419", value: {'Location.district': "Porto", 'Activity.id': 419, 'Activity.activity': "Actividades de contabilidade e auditoria;  consultoria fiscal", 'Facts.count': 1481, 'Facts.providesService': 0}},
  {key: "Porto424", value: {'Location.district': "Porto", 'Activity.id': 424, 'Activity.activity': "Outras actividades de consultoria para os negócios e a gestão", 'Facts.count': 1271, 'Facts.providesService': 0}},
  {key: "Porto454", value: {'Location.district': "Porto", 'Activity.id': 454, 'Activity.activity': "Transportes rodoviários de mercadorias", 'Facts.count': 1244, 'Facts.providesService': 0}},
  {key: "Porto484", value: {'Location.district': "Porto", 'Activity.id': 484, 'Activity.activity': "Actividades de mediação imobiliária", 'Facts.count': 972, 'Facts.providesService': 0}},
  {key: "Porto494", value: {'Location.district': "Porto", 'Activity.id': 494, 'Activity.activity': "Manutenção e reparação de veículos automóveis", 'Facts.count': 920, 'Facts.providesService': 0}},
  {key: "Porto495", value: {'Location.district': "Porto", 'Activity.id': 495, 'Activity.activity': "Confecção de outro vestuário exterior em série", 'Facts.count': 876, 'Facts.providesService': 0}}
]
//var seriesActivities = getLocationActivities(districtLabels, districtActivities, "Location.district")
var activityLabels = topTenActivities
//var districtLabels = getDistricts()
//var districtActivities = getDistrictsActivies()
var seriesActivities = getLocationActivities(districtLabels, districtActivities, "Location.district")

export default {
  name: "StackDistricts",
  components: {
    apexchart: VueApexCharts
  },
  data: function() {
    return {
      labels: activityLabels,
      series: seriesActivities,
      chartOptions: {
        labels: activityLabels,
        chart: {
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false
          }
        },

        xaxis: {
          type: "string",
          categories: activityLabels
        },
        legend: {
          position: "right",
          offsetY: 40
        },
        fill: {
          opacity: 1
        }
      }
    }
  }
}
</script>

<style scoped></style>
